/**
 * RAOC-22 PR-2 — Internal helper for `useRovoConfig`.
 *
 * Not exported via a package subpath — consumers should not import this
 * directly; the canonical way to fire a degraded-dependency event is by
 * passing analytics callbacks into the hook.
 *
 * NOTE: `FireAnalyticsEvent` is intentionally not imported from search-page
 * to avoid a cross-package cycle. We type the return value structurally to
 * match the search-page shape — search-page's `FireAnalyticsEvent` and ours
 * are compatible at the structural level (both extend `GasPayload &
 * AnalyticsAttributes`).
 */

import { type FireAnalyticsEvent } from '../../common/utils/analytics/types';

type DegradableDependency = 'combined-config' | 'outbound-auth-github';

type onDegradedDependencyArgs = {
	dependency: DegradableDependency;
	searchSessionId: string;
	reason: string;
	source: string;
};

// Fires an event when a dependency fails or times out.
// Note: should be fired at the request level, so the UX may not be affected
// due to e.g. caching.
export const onDegradedDependency = ({
	dependency,
	searchSessionId,
	reason,
	source,
}: onDegradedDependencyArgs): FireAnalyticsEvent => {
	return {
		source,
		action: 'degradedDependency',
		actionSubject: 'rovoConnectorsConfig',
		eventType: 'track',
		attributes: {
			additionalAttributes: {
				degradedDependency: dependency,
				reason,
				searchSessionId,
			},
		},
	};
};
